import { render, staticRenderFns } from "./cruuency_pc.vue?vue&type=template&id=3b62aaf0&scoped=true"
import script from "./cruuency_pc.vue?vue&type=script&lang=js"
export * from "./cruuency_pc.vue?vue&type=script&lang=js"
import style0 from "./cruuency_pc.vue?vue&type=style&index=0&id=3b62aaf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b62aaf0",
  null
  
)

export default component.exports